module.exports = __webpack_public_path__ + "static/media/Group.97391a06.svg";